import styled from 'styled-components';
import { Dialog } from 'components/Modal';

export const Container = styled(Dialog)`
  margin-top: 162px;
  line-height: normal;
`;
